import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/AuthProvider';
import routes from './adminRoutes';

const ADMIN_PATH = '/admin';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, sessionUser } = useAuth();
    const location = useLocation();

    // Check for authentication
    if (!isAuthenticated) {
        let notifications = [
            {
                type: "warning",
                message: "You have tried to access a page which requires you to log in.",
                autoClose: 8000 
            }
        ];
        return <Navigate to="/" replace state={{notifications: notifications}} />;
    }

    const matchedRoute = routes.find(({ path }) => path === location.pathname.replace(ADMIN_PATH, ''));

    if (Object.keys(sessionUser).length !== 0 && matchedRoute) {
        const { level } = matchedRoute;
        let hasPermission = false;

        // Check if route needs permission
        if (level) {
            hasPermission = (sessionUser.role.permissionLevel <= level) ? true : false;
        } else {
            hasPermission = true; // Route doesn't require any specific permission
        }

        if (!hasPermission) {
            let notifications = [
                {
                    type: "warning",
                    message: "You have tried to access a page which you don't have permission to access.",
                    autoClose: 8000 
                }
            ];
            const redirectPath = '/admin/jobs/list';
            return <Navigate to={redirectPath} replace state={{notifications: notifications}} />;
        }
    }

    return children;
};

export default ProtectedRoute;
